import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ApiPaths } from "../../../api/paths";
import ActiveShieldIcon from "../../../components/icons/ActiveShieldIcon";
import ShieldCard from "../../../components/shield-card/ShieldCard";
import useData from "../../../hooks/use-data";
import { CoverStatisticsType } from "../../../types/cover";
import { useAppContext } from "../../../context/app-context";
import { toast } from "react-toastify";

export default function MyCoversStats() {
  const { keycloakProfile } = useAppContext();
  const { t } = useTranslation(["myCovers"]);
  const params = useMemo(
    () => ({
      params: {
        search: keycloakProfile?.email,
      },
    }),
    [keycloakProfile?.email]
  );
  const { data } = useData<CoverStatisticsType>(ApiPaths.coversStatistics, {
    options: params,
    onError: () => {
      toast(t("mutate_Profile.error.fetch_single", { ns: "myProfile" }), {
        type: "error",
      });
    },
    fetchIf: !!keycloakProfile?.email,
  });
  const mapData = useMemo(
    () => [
      {
        name: t("stats.total_covers", { ns: "myCovers" }),
        qty: data?.coverStatistics?.total_covers,
        color: "bg-active-covers",
        shieldColor: "bg-active-covers-shield",
        tooltip: t("stats.tooltip.total_covers", { ns: "myCovers" }),
        icon: <ActiveShieldIcon />,
      },
      {
        name: t("stats.expiring_covers", { ns: "myCovers" }),
        qty: data?.coverStatistics?.expiring_covers,
        color: "bg-expiring-covers",
        shieldColor: "bg-active-claims-shield",
        tooltip: t("stats.tooltip.expiring_covers", { ns: "myCovers" }),
        icon: <ActiveShieldIcon />,
      },
      {
        name: t("stats.expired_covers", { ns: "myCovers" }),
        qty: data?.coverStatistics?.expired_covers,
        color: "bg-expired-covers",
        shieldColor: "bg-active-claims-shield",
        tooltip: t("stats.tooltip.expired_covers", { ns: "myCovers" }),
        icon: <ActiveShieldIcon />,
      },
      {
        name: t("stats.pending_covers", { ns: "myCovers" }),
        qty: data?.coverStatistics?.pending_covers,
        color: "bg-pending-covers",
        shieldColor: "bg-pending-covers-shield",
        tooltip: t("stats.tooltip.pending_covers", { ns: "myCovers" }),
        icon: <ActiveShieldIcon />,
      },
    ],
    [data]
  );
  return (
    <div className="row">
      {mapData.map((stat) => {
        return (
          <div className="col-6 col-md-3 pb-3" key={stat.name}>
            <ShieldCard
              name={stat.name}
              qty={stat.qty}
              color={stat.color}
              shieldColor={stat.shieldColor}
              tooltip={stat.tooltip}
              icon={stat.icon}
            />
          </div>
        );
      })}
    </div>
  );
}
